import { useRef } from "react";
import { isEqual } from "lodash-es";
function useDeepMemo(factory, deps) {
    const ref = useRef();
    if (void 0 === ref.current || false === isEqual(deps, ref.current.deps)) ref.current = {
        value: factory(),
        deps
    };
    return ref.current.value;
}
export { useDeepMemo };

//# sourceMappingURL=deep-memo.js.map